module.exports = __webpack_public_path__ + "media/images/profile-02-p-130x130q80-8ff97895761764ebf46828a467c50ca4.png";